import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createPoll } from '../../utils/createPoll'
import SearchProviderContainer from '../search/SearchProviderContainer'
import { showNotification } from '../../actions/notifications'
import { useSearchContext } from '../../services/search/SearchContext'
import SectionHomeAddToClassCell from '../../components/section/sectionHome/sectionHomeQueue/SectionHomeAddToClassCell'

// modal where user can search content and add to the queue
// opened from section home page
// if section has empty queue we show some recent items that they may want to add and a search button which opens this modal

function SearchBar() {
  const { currentRefinement, refine } = useSearchContext()
  const isEmpty = currentRefinement === ''
  return (
    <div className={`addToClassSearch${isEmpty ? ' is--empty' : ' is--nonEmpty'}`}>
      <input
        type='text'
        autoFocus
        required
        placeholder='Search'
        value={currentRefinement}
        onChange={(e) => {
          refine(e.target.value)
        }}
      />
    </div>
  )
}

function SearchResults({ addToQueue }) {
  const { hits } = useSearchContext()

  return (
    <div className='addToClassSearch-resultsList'>
      {hits.map((item, index) => (
        <SectionHomeAddToClassCell item={item} addToQueue={addToQueue} key={`algolia-${index}`} />
      ))}
    </div>
  )
}

class SectionHomeAddToClassSearchModalContainer extends Component {
  constructor() {
    super()
    this.handleAddToQueue = this.handleAddToQueue.bind(this)
  }

  handleAddToQueue(suggestion) {
    this.props.createPoll(suggestion, this.props.sectionId).then(() => {
      this.props.hideModal()
      const notificationMessage = `${suggestion.name || suggestion.body} to Class`
      this.props.showNotification(notificationMessage, 'Added', 'default')
    })
  }

  render() {
    return (
      <div className='addFromLibrary'>
        <SearchProviderContainer isSectionHome>
          <SearchBar />
          <SearchResults addToQueue={this.handleAddToQueue} />
        </SearchProviderContainer>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    sectionId: state.modals.sectionId,
  }),
  { createPoll, showNotification },
)(SectionHomeAddToClassSearchModalContainer)
